import PropTypes from 'prop-types';
import PrerollAdSlot from './PrerollAdSlot';
import PrerollControls from './controls/PrerollControls';
import { PREROLL_DISPLAY_SLOT_NAME_AND_ID } from './constants/displayAds';
import css from './preroll.module.scss';

const baseStyles = {
  position: 'absolute',
  bottom: 0,
  boxSizing: 'content-box',
  transition: '750ms',
};

export default function PrerollViewContainer({
  breakpoint,
  width,
  isMinimized,
}) {
  const styles = {
    expanded: {
      height: 72,
      width,
    },
    minimized: {
      height: 36,
      width: width / 2,
    },
  };

  const appliedPrerollControlStyles = isMinimized
    ? {
        ...baseStyles,
        ...styles.minimized,
      }
    : {
        ...baseStyles,
        ...styles.expanded,
      };

  return (
    <div>
      <div className={css.prerollVideoContainer}>
        <PrerollAdSlot
          id={PREROLL_DISPLAY_SLOT_NAME_AND_ID}
          slotName={PREROLL_DISPLAY_SLOT_NAME_AND_ID}
          breakpoint={breakpoint}
          deregisterDisplaySlot={false}
        />
      </div>
      <div style={appliedPrerollControlStyles}>
        <PrerollControls isMinimized={isMinimized} />
      </div>
    </div>
  );
}

PrerollViewContainer.propTypes = {
  breakpoint: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  isMinimized: PropTypes.bool.isRequired,
};
